import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import FilmListComponent from './FilmListComponent'
import SearchComponent from './SearchComponent';
import { useState } from 'react';

function App() {
  const [query, setQuery] = useState("");
  const isQueryEmpty = query.trim() === "";

  const onTrendingClick = () => {
    if (isQueryEmpty) return;
    setQuery("");
  }

  return (
    <div className="page-background">

      <nav className="navbar bg-dark navbar-expand-lg sticky-top ps-3 pe-3">
        <div className="container-fluid">
          <a class="navbar-brand text-light" href="#top" onClick={onTrendingClick}>Film Keeper</a>
          <div className="navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto">
              <li className="nav-item">
                <a className="nav-link text-light btn btn-dark" href="#top" onClick={onTrendingClick}>Home</a>
              </li>
              <li className="nav-item">
                <a className="nav-link text-light btn btn-dark" href="#donate">Donate</a>
              </li>
            </ul>
            <div className="search">
              <SearchComponent onSearchSubmit={(value) => setQuery(value)} />
            </div>
          </div>
        </div>
      </nav>

      <div>
        <section class="text-center text-bg-dark bg-dark bg-gradient">
          <div className="row">
            <div className="col-lg-6 col-md-8 mx-auto mt-2">
              <h2 className=''>About</h2>
              <p className='ms-5 me-5' id="about">
                We want to help you know whether a movie or TV show has LGBTQ+ themes. You are free to decide whether to watch after finding out.
              </p>
            </div>
          </div>
        </section>
      </div>

      <div>
        <div className="film-width text-light mx-auto m-3">
          {isQueryEmpty ? (
            <div>
              <h2 className='text-center pb-3'><strong>Trending</strong></h2>
              <FilmListComponent />
            </div>
          ) : (
            <div>
              <FilmListComponent query={query} />
            </div>
          )}
        </div>
      </div>

      <div>
        <section class="text-center text-bg-dark">
          <div className="row">
            <div className="col-lg-6 col-md-8 mx-auto mt-4">
              <h2 className=''>Contribute</h2>
              <p className='ms-5 me-5'>The movies are flagged by maintainer of this site so if you want to help him, feel free to use Report button for each movie you want to be verified for LGBTQ+ presence.</p>
              <h2 className=''>Donate</h2>
              <p className='ms-5 me-5'>If you like our resource and you want to support this project, use the button below.</p>
              <p className='mt-3'>Donations are powered by Buy Me a Coffee</p>
              <a type="button" className="btn btn-primary" rel="noreferrer" target='_blank' id='donate' href='https://buymeacoffee.com/filmkeeper'>Donate</a>
              <h2 className='mt-3'>Support</h2>
              <p className='mb-4 mt-3'>Email: <a href='mailto:filmkeeper@proton.me'>filmkeeper@proton.me</a></p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default App;
